<template>
  <div id="app">
    <!-- 数据大屏页面：全屏展示，隐藏顶部布局 -->
    <router-view v-if="isFullscreen" />
    <!-- 普通页面：带顶部导航布局 -->
    <div v-else class="layout">
      <header class="app-header">
        <h1 @click="goHome">📊 Dashboard</h1>
        <nav class="nav">
          <router-link to="/">首页</router-link>
          <router-link to="/about">关于</router-link>
        </nav>
      </header>
      <main class="app-main">
        <router-view />
      </main>

      <quick-links />

    </div>


  </div>
</template>

<script>
import QuickLinks from './components/QuickLinks.vue';
export default {
  name: 'App',
  components: { QuickLinks },
  computed: {
    isFullscreen () {
      return Boolean(this.$route.meta && this.$route.meta.fullscreen)
    }
  },
  methods: {
    goHome () {
      if (this.$route.path === '/') {
        return
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  color: #2c3e50;
  background-color: #f5f7fa;
}

#app {
  width: 100%;
  height: 100%;
}

.layout {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 28px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  margin-bottom: 24px;
}

.app-header h1 {
  font-size: 22px;
  color: #2c3e50;
}

.nav {
  display: flex;
  gap: 20px;
}

.nav a {
  text-decoration: none;
  color: #606266;
  font-size: 15px;
  padding: 6px 12px;
  border-radius: 6px;
  transition: all 0.2s;
}

.nav a:hover {
  color: #409eff;
  background: #ecf5ff;
}

.nav a.router-link-exact-active {
  color: #409eff;
  background: #ecf5ff;
  font-weight: 500;
}

.app-main {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 28px;
  min-height: 400px;
}
</style>
